import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { loadFile, resetFile } from '../actions/upload-file.actions';
import { UploadScreenInfo} from "src/app/shared/components/atoms/file-upload-component/model/file-uplaod.interface";

const initialState: UploadScreenInfo = {
    fileDoc: [],
    ciValidationRequired: false,
};
const getUploadFileState = createFeatureSelector<UploadScreenInfo>('UploadFileInfo');
export const getUploadFile = createSelector(getUploadFileState, (state) => state);
export const uploadFileReducer = createReducer<UploadScreenInfo>(
  initialState,
  on(loadFile, (state, props): UploadScreenInfo => ({ ...state, ...props.uploadFileInfo })),
  on(resetFile, () => initialState),
);